import { withUrlStateSlice } from "@/common/helpers/url-state";

type ConflictOverview =
  | { path: string; tableName: string; hash?: string }
  | { path: string; searchParam: string; hash?: string };

const conflictOverviews: Record<string, ConflictOverview> = {
  branches: {
    path: "/masterdata/branch",
    tableName: "branch-table",
  },
  modelFamilies: {
    path: "/masterdata/model-family",
    tableName: "model-family-table",
  },
  modelGenerations: {
    path: "/masterdata/model-generation",
    tableName: "model-generation-table",
  },
  vehicles: {
    path: "/masterdata/vehicle",
    tableName: "vehicle-table",
  },
  priceAdjustment: {
    path: "/fab/settings",
    searchParam: "search",
    hash: "price-adjustments",
  },
};

export function createConflictOverviewPath(conflictKey: string, recordUuids: string[]): string | undefined {
  const overview = conflictOverviews[conflictKey];
  const uniqueRecordUuids = [...new Set(recordUuids.filter(Boolean))];

  if (!overview || uniqueRecordUuids.length === 0) {
    return undefined;
  }

  const search = uniqueRecordUuids.map((uuid) => `uuid:${uuid}`).join(" OR ");
  const searchParams =
    "tableName" in overview
      ? withUrlStateSlice(new URLSearchParams(), overview.tableName, { search })
      : new URLSearchParams({ [overview.searchParam]: search });
  const hash = overview.hash ? `#${overview.hash}` : "";

  return `${overview.path}?${searchParams.toString()}${hash}`;
}
